import * as Schema from "effect/Schema";
import { TrimmedNonEmptyString } from "./baseSchemas.ts";

/** Canonical mailbox address, without a display name or header delimiters. */
export const EmailAddress = Schema.String.check(
  Schema.isMaxLength(254),
  Schema.isPattern(
    /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9.-]*[A-Za-z0-9])?\.[A-Za-z]{2,}$/,
  ),
);
export const MailIdentifier = TrimmedNonEmptyString.check(
  Schema.isMaxLength(2048),
  Schema.isPattern(/^[^\r\n]+$/),
);
export const EmailDeliveryDestination = Schema.Struct({
  kind: Schema.Literal("email"),
  to: Schema.Array(EmailAddress).check(Schema.isMinLength(1), Schema.isMaxLength(20)),
  thread: Schema.Union([
    Schema.Struct({ mode: Schema.Literal("ongoing") }),
    Schema.Struct({ mode: Schema.Literal("per_run") }),
    Schema.Struct({ mode: Schema.Literal("existing"), threadId: MailIdentifier }),
  ]),
});
export type EmailDeliveryDestination = typeof EmailDeliveryDestination.Type;
export const EmailMailboxStatus = Schema.Struct({
  workspaceId: MailIdentifier,
  id: MailIdentifier,
  address: EmailAddress,
  state: Schema.Literals(["pending", "ready", "paused", "needs_attention", "disconnected"]),
  statusMessage: Schema.optionalKey(Schema.String),
});
export type EmailMailboxStatus = typeof EmailMailboxStatus.Type;

export const EmailConversationChannelBinding = Schema.Struct({
  connectorId: Schema.Literal("email"),
  installationId: MailIdentifier,
  generation: Schema.Int,
  threadId: MailIdentifier,
  externalParticipantId: EmailAddress,
});
export type EmailConversationChannelBinding = typeof EmailConversationChannelBinding.Type;
export const EmailMember = Schema.Struct({
  principalId: MailIdentifier,
  email: EmailAddress,
  name: Schema.String,
});
export type EmailMember = typeof EmailMember.Type;

export const EmailSetupStatus = Schema.Struct({
  configured: Schema.Boolean,
  mailbox: Schema.optionalKey(EmailMailboxStatus),
  message: Schema.optionalKey(Schema.String),
});
export type EmailSetupStatus = typeof EmailSetupStatus.Type;
export const EmailActionInput = Schema.Struct({
  projectId: MailIdentifier,
  action: Schema.Literals(["ensure", "pause", "resume", "disconnect", "reconnect", "delete"]),
});
export type EmailActionInput = typeof EmailActionInput.Type;
